import CauseList from "../components/CauseList";

const ListCausePage = () => {
  return (
    <CauseList />
  );
};

export default ListCausePage;
